import { render, staticRenderFns } from "./DetailBarangMasuk.vue?vue&type=template&id=971c8cc6"
import script from "./DetailBarangMasuk.vue?vue&type=script&lang=js"
export * from "./DetailBarangMasuk.vue?vue&type=script&lang=js"
import style0 from "./DetailBarangMasuk.vue?vue&type=style&index=0&id=971c8cc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports